export const defaultAmount = 10;
export const amountOptions = [10, 25, 50, 100, 200];
export const typeOptions: ["fi", "rf"] = ["fi", "rf"];
